import { render, staticRenderFns } from "./GroupViews.vue?vue&type=template&id=4c7275ee&scoped=true"
import script from "./GroupViews.vue?vue&type=script&lang=js"
export * from "./GroupViews.vue?vue&type=script&lang=js"
import style0 from "./GroupViews.vue?vue&type=style&index=0&id=4c7275ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7275ee",
  null
  
)

export default component.exports